import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function CircularComponent() {
    return (
        <Box sx={{ display: 'flex', marginLeft: '2em' }}>
            <CircularProgress size="2em" />
        </Box>
    );
}
